import { Box, Button, Typography, Tooltip } from "@material-ui/core";
import React from "react";
import { useTheme } from '../constants/themeProvider';
import { ColorsConstant } from "./colorConstant";

const OverlayButton = (props) => {
    const { title, onClick, classStyleHeading, classStyleText, disabled, disabledTooltip } = props;
    const theme = useTheme();

    const button = (
        <Button style={{background: disabled ? '#a0a0a0' : theme?.primaryColor, borderColor: ColorsConstant.headerColor, opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer', pointerEvents: disabled ? 'none' : 'auto'}} className={classStyleHeading ? classStyleHeading : ''} onClick={onClick} disabled={disabled ? disabled : false }>
            <Box className={classStyleText ? classStyleText : ''}>
            <Typography variant="inherit" style={{color: theme?.primaryFontText}}>
              {title}
            </Typography>
            </Box>
        </Button>
    );

    if (disabled && disabledTooltip) {
        return (
            <Tooltip title={disabledTooltip} arrow placement="bottom">
                <span style={{ cursor: 'not-allowed' }}>{button}</span>
            </Tooltip>
        );
    }

    return button;
};

export default OverlayButton;